import { render } from "./ImageDimensionsComponent.vue?vue&type=template&id=0af4729f&scoped=true"
import script from "./ImageDimensionsComponent.vue?vue&type=script&lang=js"
export * from "./ImageDimensionsComponent.vue?vue&type=script&lang=js"

import "./ImageDimensionsComponent.vue?vue&type=style&index=0&id=0af4729f&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af4729f"]])

export default __exports__